import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { AppConfig } from './app/app.config';

if (AppConfig.environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule);
